import { Box, ThemeProvider } from '@mui/material';
import { ReactNode } from 'react';
import { lightNeutral } from 'src/colors';
import { useSettingsStore } from 'src/store/settings-store';
import { createCustomTheme } from 'src/theme';

interface Props {
  children: ReactNode;
  actionsSlot: ReactNode;
}

const AuthFormWrapper = ({ children, actionsSlot }: Props) => {
  const settingsDirection = useSettingsStore(state => state.direction);

  const theme = createCustomTheme({
    direction: settingsDirection,
    theme: 'light',
  });

  return (
    <ThemeProvider theme={theme}>
      <Box
        sx={{
          display: 'flex',
          height: '100%',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
          backgroundColor: 'primary.contrast',
        }}>
        <Box
          sx={{
            width: '480px',
            background: lightNeutral['100'],
            borderRadius: 4,
            boxShadow: '0px 36px 46px 0px rgba(9, 30, 66, 0.12)',
          }}>
          <Box
            sx={{
              p: 4,
              pb: 0,
              display: 'flex',
              flexDirection: 'column',
              gap: 2,
            }}>
            {children}
          </Box>
          <Box
            sx={{
              p: 4,
              pt: 0,
              display: 'flex',
              justifyContent: 'flex-end',
              mt: 2,
            }}>
            {actionsSlot}
          </Box>
        </Box>
      </Box>
    </ThemeProvider>
  );
};

export default AuthFormWrapper;
